import { withErrorCode } from '@/lib/errors'
import { formatUserFacingError } from '@/lib/errors'
import { useEffect, useState } from 'react'
import { festivalsService } from '../services/festivals.service'
import type { FestivalDocument, FestivalEditionDocument } from '@/types'

interface UseFestivalResult {
  festival: (FestivalDocument & { id: string }) | null
  editions: Array<FestivalEditionDocument & { id: string }>
  loading: boolean
  error: string | null
}

export function useFestival(slug: string): UseFestivalResult {
  const [festival, setFestival] = useState<(FestivalDocument & { id: string }) | null>(null)
  const [editions, setEditions] = useState<Array<FestivalEditionDocument & { id: string }>>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    festivalsService
      .getFestivalBySlug(slug)
      .then(async (fest) => {
        if (!fest) { setError(withErrorCode('Festival not found', 'app/validation')); return }
        setFestival(fest)
        const eds = await festivalsService.getEditions(fest.id)
        setEditions(eds)
      })
      .catch((err: unknown) =>
        setError(formatUserFacingError(err, 'Failed to load festival'))
      )
      .finally(() => setLoading(false))
  }, [slug])

  return { festival, editions, loading, error }
}
